import classNames from 'classnames';

const baseClassName = classNames([
  'bg-field',
  'text-default', // text color
  'placeholder:text-muted', // placeholder color
  'border border-field',
  'hover:border-field-hover',
  'focus:border-control-focus',
  'focus:hover:border-control-focus',
  'disabled:pointer-events-none disabled:opacity-60', // locked / disabled state — suppresses hover
  'w-full',
  'shadow-none',
  'rounded-md',
  'focus:outline-none',
]);
export default baseClassName;

export type InputSize = 'sm' | 'md' | 'lg';
export type InputVariant = 'success' | 'critical';

export const inputVariantClassNames: Record<InputVariant, string> = {
  success: '!border-alert-success',
  critical: '!border-alert-critical',
};

export const inputSizeClassNames: Record<InputSize, string> = {
  sm: 'h-7 text-sm leading-normal',
  md: 'h-10 text-base leading-normal',
  lg: 'h-14 text-base leading-normal',
};

export const inputPaddingClassNames: Record<InputSize, string> = {
  sm: 'px-2',
  md: 'px-3.5',
  lg: 'px-4',
};

export const inputIconStartPaddingClassNames: Record<InputSize, string> = {
  sm: 'pl-9 pr-2',
  md: 'pl-11 pr-3.5',
  lg: 'pl-12 pr-4',
};

export const inputIconStartInsetClassNames: Record<InputSize, string> = {
  sm: 'left-2',
  md: 'left-3',
  lg: 'left-4',
};

export const bareInputClassName =
  'w-full border-0 bg-transparent text-default placeholder:text-muted outline-none focus:outline-none';

/** Shared filled-field styling for custom button triggers. */
export const inputControlClassNames: Record<InputSize, string> = {
  sm: `${baseClassName} ${inputSizeClassNames.sm} ${inputPaddingClassNames.sm}`,
  md: `${baseClassName} ${inputSizeClassNames.md} ${inputPaddingClassNames.md}`,
  lg: `${baseClassName} ${inputSizeClassNames.lg} ${inputPaddingClassNames.lg}`,
};
